import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeaturesRoutingModule } from './features-routing.module';
import { EndorsesModule } from './endorses/endorses.module';
import { ReportsModule } from './reports/reports.module';
import { CoreModule } from '../core/core.module';

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    FeaturesRoutingModule,
    EndorsesModule,
    ReportsModule
  ],
  exports: [FeaturesRoutingModule]
})
export class FeaturesModule { }
